// import React, { useCallback, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { DContext } from "../../../context/Datacontext";
// import CreateCourseModal from "./CreateCourseModal";
// import { fetchSyllbus } from "../../../services/coures/fetchSyllbus";
// import { Pagination } from "../../../utils/Pagination";

// export const MyCourse = () => {
//   const { BeURL} = useContext(DContext);
//   const navigate = useNavigate();

//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [departments, setDepartments] = useState([]);

//   const [search, setSearch] = useState("");

//   const [page, setPage] = useState(() =>
//     Number(localStorage.getItem("coursePage")) || 1
//   );

//   const [limit, setLimit] = useState(() =>
//     Number(localStorage.getItem("courseLimit")) || 10
//   );

//   const [totalCourses, setTotalCourses] = useState(0);

//   // save pagination state
//   useEffect(() => {
//     localStorage.setItem("coursePage", page);
//     localStorage.setItem("courseLimit", limit);
//   }, [page, limit]);

//   const fetchInstructorCourses = useCallback(
//     async (p = page, l = limit, q = search) => {
//       try {
//         setLoading(true);

//         const params = new URLSearchParams();
//         params.set("page", p);
//         params.set("limit", l);
//         if (q?.trim()) params.set("search", q.trim());

//         const res = await fetch(`${BeURL}/courses?${params.toString()}`, {
//           credentials: "include",
//         });

//         const data = await res.json();

//         if (data.success) {
//           setCourses(data.courses || []);
//           setTotalCourses(data.total || 0);
//         } else {
//           setCourses([]);
//           setTotalCourses(0);
//         }
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [BeURL, page, limit, search]
//   );

//   useEffect(() => {
//     fetchInstructorCourses(page, limit, search);
//   }, [page, limit, search, fetchInstructorCourses]);

//   const fetchDepartments = useCallback(async () => {
//     try {
//       const res = await fetchSyllbus({ BeURL });
//       if (res?.success) {
//         setDepartments(res.departmentChips || []);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   }, [BeURL]);

//   useEffect(() => {
//     fetchDepartments();
//   }, [fetchDepartments]);

//   const safe = (val) => {
//     if (val === null || val === undefined) return "-";
//     if (typeof val === "string" || typeof val === "number") return val;
//     if (typeof val === "object") return JSON.stringify(val);
//     return "-";
//   };

//   const totalPages = Math.max(1, Math.ceil(totalCourses / limit));

//   const handleManage = (id) => {
//     navigate(`/instructor/managecourse/${id}`);
//   };

//   if (loading) return <div className="p-6">Loading...</div>;

//   return (
//     <div className="p-6 space-y-6 min-h-screen">

//       <div className="flex justify-between items-center">
//         <h2 className="text-2xl font-bold">My Courses</h2>

//         <div className="flex gap-3">
//           <input
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setPage(1);
//             }}
//             className="border px-3 py-2 rounded-lg"
//           />

//           <button
//             onClick={() => setOpenModal(true)}
//             className="px-4 py-2 bg-primary-600 text-white rounded-lg"
//           >
//             Create Course
//           </button>
//         </div>
//       </div>

//       {totalCourses === 0 ? (
//         <p>No courses created yet</p>
//       ) : (
//         <div className="bg-white rounded-xl shadow overflow-hidden">
//           <table className="min-w-full text-sm">
//             <thead className="bg-primary-100 text-primary-600">
//               <tr>
//                 <th className="px-4 py-3 text-left">Sl.No</th>
//                 <th className="px-4 py-3 text-left">Code</th>
//                 <th className="px-4 py-3 text-left">Title</th>
//                 <th className="px-4 py-3 text-left">Level</th>
//                 <th className="px-4 py-3 text-left">Language</th>
//                 <th className="px-4 py-3 text-left">Status</th>
//                 <th className="px-4 py-3 text-left">Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {courses.map((course, idx) => {

//                 const stage =
//                   Array.isArray(course?.status) &&
//                   course.status.slice(-1)[0]?.stage;

//                 const badge =
//                   stage === "approved"
//                     ? "bg-green-100 text-green-700"
//                     : stage === "rejected"
//                       ? "bg-red-100 text-red-700"
//                       : stage === "pending"
//                         ? "bg-yellow-100 text-yellow-700"
//                         : "bg-gray-100 text-gray-700";

//                 return (
//                   <tr key={course._id} className="border-t hover:bg-gray-50">

//                     <td className="px-4 py-3">
//                       {(page - 1) * limit + idx + 1}
//                     </td>

//                     <td className="px-4 py-3">{safe(course.code)}</td>
//                     <td className="px-4 py-3 font-medium">{safe(course.title)}</td>
//                     <td className="px-4 py-3 capitalize">{safe(course.level)}</td>
//                     <td className="px-4 py-3">{safe(course.language)}</td>

//                     <td className="px-4 py-3">
//                       <span className={`px-2 py-1 text-xs rounded ${badge}`}>
//                         {stage}
//                       </span>
//                     </td>

//                     <td className="px-4 py-3">
//                       <button
//                         onClick={() => handleManage(course._id)}
//                         className="px-3 py-1 bg-secondary-600 text-white rounded-md"
//                       >
//                         Manage
//                       </button>
//                     </td>

//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>

//           <div className="p-4 border-t">
//             <Pagination
//               page={page}
//               totalPages={totalPages}
//               limit={limit}
//               totalUsers={totalCourses}
//               setPage={setPage}
//               setLimit={(newLimit) => {

//                 const firstIndex = (page - 1) * limit;
//                 const newPage = Math.floor(firstIndex / newLimit) + 1;

//                 setLimit(newLimit);
//                 setPage(newPage);

//               }}
//             />
//           </div>

//         </div>
//       )}

//       <CreateCourseModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         onCreated={() => {
//           fetchInstructorCourses(page, limit, search);
//           setOpenModal(false);
//         }}
//         departments={departments}
//         courses={courses}
//       />

//     </div>
//   );
// };




import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DContext } from "../../../context/Datacontext";
import CreateCourseModal from "./CreateCourseModal";
import { fetchSyllbus } from "../../../services/coures/fetchSyllbus";
import { Pagination } from "../../../utils/Pagination";

export const MyCourse = () => {

  const { BeURL } = useContext(DContext);
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [departments, setDepartments] = useState([]);

  const [search, setSearch] = useState("");
  const searchTimeout = useRef(null);

  const [page, setPage] = useState(
    () => Number(localStorage.getItem("coursePage")) || 1
  );

  const [limit, setLimit] = useState(
    () => Number(localStorage.getItem("courseLimit")) || 10
  );

  const [totalCourses, setTotalCourses] = useState(0);

  useEffect(() => {
    localStorage.setItem("coursePage", page);
    localStorage.setItem("courseLimit", limit);
  }, [page, limit]);

  const fetchInstructorCourses = useCallback(
    async (p, l, q) => {

      try {

        setLoading(true);

        const params = new URLSearchParams();
        params.set("page", p);
        params.set("limit", l);

        if (q?.trim()) {
          params.set("search", q.trim());
        }

        const res = await fetch(`${BeURL}/courses?${params.toString()}`, {
          credentials: "include"
        });

        const data = await res.json();

        if (data.success) {
          setCourses(data.courses || []);
          setTotalCourses(data.total || 0);
        } else {
          setCourses([]);
          setTotalCourses(0);
        }

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }

    },
    [BeURL]
  );

  useEffect(() => {
    fetchInstructorCourses(page, limit, search);
  }, [page, limit, search, fetchInstructorCourses]);

  const fetchDepartments = useCallback(async () => {

    try {

      const res = await fetchSyllbus({ BeURL });

      if (res?.success) {
        setDepartments(res.departmentChips || []);
      }

    } catch (err) {
      console.error(err);
    }

  }, [BeURL]);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  const handleSearch = (value) => {

    setSearch(value);
    setPage(1);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      fetchInstructorCourses(1, limit, value);
    }, 400);

  };

  const safe = (val) => {

    if (val === null || val === undefined) return "-";
    if (typeof val === "string" || typeof val === "number") return val;
    if (typeof val === "object") return JSON.stringify(val);
    return "-";

  };

  const totalPages = Math.max(1, Math.ceil(totalCourses / limit));

  const handleManage = (id) => {
    navigate(`/instructor/managecourse/${id}`);
  };

  return (

    <div className="p-6 space-y-6 min-h-screen">

      <div className="flex justify-between items-center">

        <h2 className="text-2xl font-bold">
          My Courses
        </h2>

        <div className="flex gap-3">

          <input
            placeholder="Search courses..."
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            className="border px-3 py-2 rounded-lg w-64"
          />

          <button
            onClick={() => setOpenModal(true)}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg"
          >
            Create Course
          </button>

        </div>

      </div>

      {totalCourses === 0 ? (

        <p>No courses found</p>

      ) : (

        <div className="bg-white rounded-xl shadow overflow-hidden">

          <table className="min-w-full text-sm">

            <thead className="bg-primary-100 text-primary-600">

              <tr>
                <th className="px-4 py-3 text-left">Sl.No</th>
                <th className="px-4 py-3 text-left">Code</th>
                <th className="px-4 py-3 text-left">Title</th>
                <th className="px-4 py-3 text-left">Level</th>
                <th className="px-4 py-3 text-left">Language</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Action</th>
              </tr>

            </thead>

            <tbody>

              {courses.map((course, idx) => {

                const stage =
                  Array.isArray(course?.status) &&
                  course.status.slice(-1)[0]?.stage;

                const badge =
                  stage === "approved"
                    ? "bg-green-100 text-green-700"
                    : stage === "rejected"
                      ? "bg-red-100 text-red-700"
                      : stage === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-gray-100 text-gray-700";

                return (

                  <tr key={course._id} className="border-t hover:bg-gray-50">

                    <td className="px-4 py-3">
                      {(page - 1) * limit + idx + 1}
                    </td>

                    <td className="px-4 py-3">
                      {safe(course.code)}
                    </td>

                    <td className="px-4 py-3 font-medium">
                      {safe(course.title)}
                    </td>

                    <td className="px-4 py-3 capitalize">
                      {safe(course.level)}
                    </td>

                    <td className="px-4 py-3">
                      {safe(course.language)}
                    </td>

                    <td className="px-4 py-3">

                      <span className={`px-2 py-1 text-xs rounded ${badge}`}>
                        {stage}
                      </span>

                    </td>

                    <td className="px-4 py-3">

                      <button
                        onClick={() => handleManage(course._id)}
                        className="px-3 py-1 bg-secondary-600 text-white rounded-md"
                      >
                        Manage
                      </button>

                    </td>

                  </tr>

                );

              })}

            </tbody>

          </table>

          <div className="p-4 border-t">

            <Pagination
              page={page}
              totalPages={totalPages}
              limit={limit}
              totalUsers={totalCourses}
              setPage={setPage}
              setLimit={(newLimit) => {

                const firstIndex = (page - 1) * limit;
                const newPage = Math.floor(firstIndex / newLimit) + 1;

                setLimit(newLimit);
                setPage(newPage);

              }}
            />

          </div>

        </div>

      )}

      <CreateCourseModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onCreated={() => {
          fetchInstructorCourses(page, limit, search);
          setOpenModal(false);
        }}
        departments={departments}
        courses={courses}
      />

    </div>
  );
};